export default __webpack_public_path__ + "static/media/bliss.14279ec9.png";